import { LOCALE_SET } from "./constants/auth";

export const localeSet = (lang: any) => ({
  type: LOCALE_SET,
  lang,
});

export const setLocale = (lang: any) => (dispatch: any) => {
  localStorage.setItem("language", lang);
  dispatch(localeSet(lang));
};
